module.exports = __webpack_public_path__ + "h5/img/weixuanzhong.bba224b9.png";